import { render, staticRenderFns } from "./vform-pc.vue?vue&type=template&id=dc1de100&scoped=true&"
import script from "./vform-pc.vue?vue&type=script&lang=js&"
export * from "./vform-pc.vue?vue&type=script&lang=js&"
import style0 from "./vform-pc.vue?vue&type=style&index=0&id=dc1de100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1de100",
  null
  
)

export default component.exports